<script setup>
/**
 * GoalLoadingOverlay
 * Full-screen loading overlay for goal data fetching
 */
defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
  message: {
    type: String,
    default: 'טוען יעד, אנא המתן...',
  },
  subMessage: {
    type: String,
    default: 'זמן הטעינה תלוי בכמות העסקאות של הסוכן ומשך תקופת היעד',
  },
})
</script>

<template>
  <Teleport to="body">
    <Transition name="fade">
      <div v-if="visible" class="loading-overlay">
        <div class="loading-window">
          <div class="loading-spinner"></div>
          <p class="loading-message">{{ message }}</p>
          <p v-if="subMessage" class="loading-sub-message">{{ subMessage }}</p>
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<style scoped>
.loading-overlay {
  position: fixed;
  inset: 0;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  background: rgba(0, 0, 0, 0.6);
  z-index: 1000;
  backdrop-filter: blur(2px);
}

.loading-window {
  width: 350px;
  max-width: 90vw;
  padding: var(--spacing-xl);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--spacing-md);
  background: var(--bg-primary);
  border-radius: 0 0 0 var(--border-radius-lg);
  box-shadow: var(--shadow-lg);
}

.loading-spinner {
  width: 48px;
  height: 48px;
  border: 4px solid var(--border-color);
  border-top-color: var(--color-primary);
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.loading-message {
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-semibold);
  color: var(--text-primary);
  text-align: center;
}

.loading-sub-message {
  font-size: var(--font-size-sm);
  color: var(--color-warning);
  text-align: center;
  max-width: 280px;
}

/* Transition */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
